import { Hero } from "@/pages/HomePage";
import { FeaturedCard } from "@/components/site/FundBits";

export default function HighIncomePage() {
  return (
    <>
      <Hero eyebrow="Harvest High Income Shares™" title="Own the worlds leading companies. Get paid every month." body="High Income Shares™ are single stock ETFs that offer exposure to top companies. The ETFs are overlaid with an active covered call strategy, seeking to generate high monthly income." cta="Learn more" />
      <section className="bg-hv-section" aria-labelledby="hhis-featured" data-testid="hhis-featured-section">
        <div className="mx-auto max-w-[1280px] px-6 py-24">
          <h2 id="hhis-featured" className="font-heading text-3xl font-bold text-hv-text md:text-4xl">Featured High Income Shares</h2>
          <div className="mt-12 grid gap-8 md:grid-cols-3">
            <FeaturedCard ticker="HHIS" internal="/high-income-shares/hhis/" />
            <FeaturedCard ticker="NVHE" internal="/high-income-shares/nvhe/" />
            <FeaturedCard ticker="NVDH" internal="/high-income-shares/nvdh/" />
          </div>
        </div>
      </section>
    </>
  );
}
